import { Component, ViewChild, OnInit, Injector} from '@angular/core';
import { PoModalComponent, PoModalAction, PoComboComponent, PoComboLiterals, PoComboOption } from '@po-ui/ng-components';
import { CompanyServices } from '../contextservices/company.service';
import { ProjectServices } from '../contextservices/project.service';
import { ContextApplication } from '../contextapplication/contextapplication';
import { Project } from '../contextapplication/models/project';
import { MenuService } from '../contextservices/menu.service';
import { MainPageComponent } from 'src/app/Home/mainpage/mainpage.component';
import { PageBase } from 'src/app/shared/library/page.base';


@Component({
  selector: 'cp-contextmodal',
  templateUrl: './contextmodal.component.html',
  styleUrls: ['./contextmodal.component.css'],
  standalone: false,
  providers: [
    CompanyServices,
    ProjectServices
  ]
})
export class ContextModalComponent extends PageBase implements OnInit {

  @ViewChild('modal', { static: true }) poModal: PoModalComponent;
  @ViewChild('combocoligada', { static: true }) comboColigada: PoComboComponent;
  @ViewChild('comboprojeto', { static: true }) comboProjeto: PoComboComponent;
  mainPage: MainPageComponent;

  poComboDefault: PoComboOption; // Não alterar os valores do combodefault
  coligadaSelecionada = true;
  projectSelected: any;

  literalsCustom: PoComboLiterals;

  constructor(public objInjector: Injector,
              public serviceColigada: CompanyServices,
              public serviceProjeto: ProjectServices,
              public contextApplication: ContextApplication,
              public menuService: MenuService)
    {
      super(objInjector);
      this.mainPage =  objInjector.get(MainPageComponent);
    }


  salvar: PoModalAction = {
    action: () => {
      if (this.comboColigada.selectedValue && this.comboProjeto.selectedValue) {
        this.SalvarContexto();
        this.poModal.close();
      }
      else {
        this.mainPage?.poNotification.warning(this.literalsCp?.strColigadaProjetoObrigatorios);
      }
    },
    label: this.literalsCp?.strSalvar
  };

  cancelar: PoModalAction = {
    action: () => {
      if (!this.contextApplication.HasContext) {
        this.mainPage?.poNotification.warning(this.literalsCp?.strColigadaProjetoObrigatorios);
      }
      else {
        this.poModal.close();
      }
    },
    label: this.literalsCp?.strCancelar
  };

  isHideLoading = true;

  ngOnInit(): void {
    super.ngOnInit();
    this.setLiterals();
    this.mainPage?.poNotification.setDefaultDuration(6000);
    if (!this.contextApplication.HasContext) {
      this.poModal.hideClose = true;
      this.poModal.open();
    }
  }

  setLiterals() {
    this.literalsCustom = {
      noData: this.literalsCp?.strNenhumRegistroEncontrado
    };
    this.cancelar.label = this.literalsCp?.strCancelar;
    this.salvar.label = this.literalsCp?.strSalvar;
  }

  openModal() {
    this.ResetCombos();
    this.poModal.open();
  }


  private ResetCombos() {
    this.comboColigada.updateSelectedValue(this.poComboDefault);
    this.comboProjeto.updateSelectedValue(this.poComboDefault);
  }

  SelecionarColigada(Coligada: any): void {
    this.comboProjeto.updateSelectedValue(this.poComboDefault);
    this.coligadaSelecionada = true;

    if (Coligada) {
      this.isHideLoading = false;
      this.menuService.HavePermission('4764f71a027e38f5bf53749d1ff678b9', 818000446, Coligada['code'])
        .then(ret => this.EnableProject(ret, Coligada));
    }
    else {
      this.coligadaSelecionada = true;
    }
  }

  EnableProject(result: boolean, coligada: any) {
    this.isHideLoading = true;
    if (result) {
      this.serviceProjeto.companyid = coligada['code'];
      this.coligadaSelecionada = false;
    }
    else {
      this.ResetCombos();
      this.mainPage?.poNotification.warning(`${this.literalsCp?.strUsuarioSemPermissaoFuncionalidade} ${coligada['name']}.`);
      this.coligadaSelecionada = true;
    }
  }


  SelecionarProjeto(Projeto: any): void {
    this.projectSelected = Projeto;
  }


  onReceiveLiterals(): void {

  }

  focusCombo() {
    this.comboColigada.focus();
  }

  SalvarContexto() {
    this.contextApplication.Project = new Project();
    this.contextApplication.Project.companyId = this.projectSelected['companyId'];
    this.contextApplication.Project.projectId = this.projectSelected['projectId'];
    this.contextApplication.Project.projectCode = this.projectSelected['projectCode'];
    this.contextApplication.Project.description = this.projectSelected['description'];
    this.contextApplication.Project.review = this.projectSelected['review'];
    if (this.projectSelected['lastCalculation']) {
      this.contextApplication.Project.lastCalculation = new Date(this.projectSelected['lastCalculation']);
    }
    if (this.projectSelected['lastBackofficeImport']) {
      this.contextApplication.Project.lastBackofficeImport = new Date(this.projectSelected['lastBackofficeImport']);
    }
    this.contextApplication.hiddenResultsDashboardTaskInput();
    this.mainPage?.taskBoard?.lookupTarefas?.setViewValue('','');
    this.mainPage?.inputBoard?.lookupInsumos?.setViewValue('','');
  }
}
